import { RESPONSE_CODES } from '@kulee/tga-constant'
import { Md5 } from 'ts-md5'
import { HTTP_ERROR_MAP } from '../constant'

/**
 * 生成签名
 * @param params 请求参数
 * @returns 签名
 */
export const generateRequestSign = (params: Record<string, string>): string => {
  const keys = Object.keys(params).sort()
  const parts = []
  for (const key of keys) {
    const value = params[key]
    if (value !== undefined && value !== null) {
      parts.push(`${key}=${value}`)
    }
  }
  const str = parts.join('&')
  return Md5.hashStr(str)
}

/**
 * 处理请求错误
 * @param error 请求错误
 * @returns 错误信息
 */
export const handleRequestError = (error: RequestError) => {
  const { code, msg: message = 'NONE' } = error
  const errorCode = HTTP_ERROR_MAP[code] || RESPONSE_CODES.UNKNOWN_ERROR
  return {
    code: errorCode,
    message,
    payload: error
  }
}

export interface RequestError {
  code: number
  msg?: string
  traceId: string
  version?: string
  data?: any
}
